<template>
    <div style="background:white; height:100%">
        <div style="display:flex;width:100%;min-width:1400px;background:white;line-height:30px;padding-top:3px;border-bottom:2px solid #389"> 
            <div style="margin-top:3px;display:flex;width:1400px; ">
                <el-popover placement="top-start"  title="说明" width="350" trigger="hover">
                    <p style="color:red"> 1、单据说明：仅显示已确认的询价单，才可以报价</p> 
                    <p style="color:red"> 2、单据说明：当单据状态为关闭时，表示结束报价</p> 
                    <span slot="reference"><i class="iconfont icon-tishi" style="color:green;font-weight:700;font-size:24px"></i></span>
                </el-popover>
                <div style="margin-right:10px;font-size:12px;margin-left:5px;">单据状态</div>
                <el-select v-model="stfgSet"   size="small" @change="stfgChange" style="width:110px">
                    <el-option label="所有订单" value="ALL"></el-option> 
                    <el-option label="已报价" value="Y"></el-option> 
                    <el-option label="未报价" value="N"></el-option> 
                </el-select>
                <span style=" margin-left:20px;font-size:12px;margin-right:10px;">字段查询</span>
                <el-select v-model="selparam" size="small" placeholder="请选择列名" filterable  style="width:130px; " >
                    <span v-for="item in reqCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
 
                <el-select v-model="selparam2" size="small" placeholder="请选择列名" filterable  style="width:130px; " >
                    <span v-for="item in reqCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam2" @keyup.enter.native="stfgChange" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div>  
        <el-table  :data="reqData"  
              border                            
              size="small"
              class="custom-table-border"
              v-loading="loading"
              :cell-style="{padding:'2px','font-size':'12px',color:'#606266'}"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 251, 255, 0.8)"
              :height="subHeight" 
              :row-key="getRowKey"
              @header-dragend="handleMainTableColumnResize"
              ref="refreq"
              highlight-current-row
              :row-class-name="tableRowClass"
              style="overflow:auto;margin-top:1px;"> 
 
            <el-table-column  v-for="item in visibleMainTableColumns" :key="item.key"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.key!=='RN'&&item.sortable=='N'"
                :min-width="item.width">
                <template  slot-scope="scope" >
                    <span v-if="item.key==='STFG'">
                        <i v-if="scope.row.STFG==='OK'" class="iconfont icon-yiqueren" style="font-size:20px;color:#409eff" ></i>
                        <i v-if="scope.row.STFG==='NO'" class="iconfont icon-weiqueren" style="font-size:20px;" ></i>
                        <i v-if="scope.row.STFG==='Y'" class="iconfont icon-yiguanbi" style="font-size:20px;color:green"></i>
                        <i v-if="scope.row.STFG==='N'" class="iconfont icon-weishenhe2" style="font-size:20px;"></i>
                    </span>
                    <span v-else-if="item.edcss==='checkbox'">
                        <el-checkbox disabled false-label="N" true-label="Y" v-model="scope.row[item.key]" >&nbsp;</el-checkbox>
                    </span>
                    <span v-else >
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repBtn(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <div v-else v-text="scope.row[item.key]" style="float:left"> </div>
                    </span>
                </template>
            </el-table-column> 
 
             <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="190">
                <template slot-scope="scope">
                    <i class="iconfont icon-chakan1" style="color:#409EFF;font-size:12px;margin-right:3px;"></i>
                    <el-link   @click="editRec(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">查看 </span></el-link>                   
                    <span v-if="scope.row.ISPRC!=='Y'">
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:3px;"></i>
                        <el-link   @click="editRec(scope.row,'N',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">编辑 </span></el-link>
                    </span>
                    <span v-if="scope.row.ISPRC!=='Y'">
                        <i class="iconfont icon-chenggong1" style="color:#409EFF;font-size:12px;margin-right:3px;"></i>
                        <el-link   @click="stfgRec(scope.row,'Y',scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">已报价 </span></el-link>
                    </span>
                    <span v-if="scope.row.ISPRC=='Y'">
                        <i class="iconfont icon-cuowukongxin" style="color:#409EFF;font-size:12px;margin-right:3px;"></i>
                        <el-link   @click="stfgRec(scope.row,'N',scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">未报价 </span></el-link>
                    </span>
 
                </template>
            </el-table-column>  
        </el-table>
        <!-- 分页查询 -->
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">确定</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="prcRow" :label-width="110"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in reqCol" :key="index" >
                        <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'&&item.key!=='UPDUSER'" :prop="item.key"  >                  
                            <el-date-picker size="medium" disabled  type="date"  v-if="item.edcss==='date'" v-model="prcRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="medium" :disabled="saveFlag" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="prcRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-input size="medium" disabled type="text" v-else   v-model="prcRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
 
                <div class="one-toolbar"><span class="spanRow">
                    1、询价产品 </span> 
                    <span style=" margin-left:20px;font-size:12px;margin-right:10px;">字段查询</span>
                    <el-select v-model="selparam3" size="small" placeholder="请选择列名" clearable  style="width:150px; " >
                        <span v-for="item in matCol" :key='item.key'>
                            <el-option :label="item.title" :value="item.key"></el-option>
                        </span>
                    </el-select>
                    <el-input :placeholder="input_hold" v-model="txtparam3" @keyup.enter.native="matQry" size="small" style="width:320px;margin-left:4px;height:30px; ">
                        <el-select v-model="oper3" slot="prepend"   style="width:100px; " >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </span>
                        </el-select>
                        <el-button size="small" slot="append" icon="el-icon-search" @click="matQry" ></el-button>
                    </el-input>
                </div>
                <el-table  :data="matData" 
                    border                            
                    size="small"
                    class="custom-table-border"
                    :height="300" 
                    :cell-style="{padding:'2px'}"
                    :row-key="getMatKey"
                    @row-click="rowClick"
                    ref="refmat"
                    highlight-current-row > 
                    <el-table-column label="序号" type="index" ></el-table-column>    
                    <el-table-column v-for="(item ,index) in matCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        sortable
                        :min-width="item.width">
                        <template slot-scope="scope" >
                            <el-checkbox v-if=" item.key==='ISOPEN'" disabled false-label="N" true-label="Y" v-model="scope.row.ISOPEN" >&nbsp;</el-checkbox>
                            <span v-else v-text="scope.row[item.key]" ></span>
                        </template>
                    </el-table-column> 
           
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="100">
                        <template slot-scope="scope">
                            <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:5px; "></i>
                            <el-link :disabled="addBool||saveFlag" @click="addQuote(scope.row)" :underline="false" ><span style="font-size:12px; ">新增报价</span></el-link> 
                        </template>
                    </el-table-column>  
                </el-table>
                <div class="one-toolbar"><span class="spanRow">2、产品报价明细 </span> </div>
                <el-table  :data="prcData" 
                    border                            
                    size="small"
                    :height="260" 
                    class="custom-table-border"
                    :cell-style="{padding:'2px'}"
                    :row-key="getPrcKey"
                    ref="refprc"
                    highlight-current-row> 
                    <el-table-column label="序号" type="index" fixed></el-table-column>
                    <span v-for="(item,index ) in prcCol" :key="index" > 
                        <el-table-column  v-if="item.thide==='N'&&item.key!=='ISOK'"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
 
                    </span> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="130">
                        <template slot-scope="scope">
                            <el-button size="mini"   type="text" icon="iconfont icon-bianji" @click="prcEdit(scope.row )">编辑</el-button>
                            <el-button size="mini"   type="text" icon="iconfont icon-shanchu" @click="prcDel(scope.row,scope.$index )">删除</el-button>
                        </template>
                    </el-table-column>  
                </el-table>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">               
                    <i v-if="prcRow['STFG']==='NO'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weiqueren"> </i>
                    <i v-else-if="prcRow['STFG']==='OK'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yiqueren"> </i> 
                    <i v-else-if="prcRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                    <i v-else-if="prcRow['STFG']==='N'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                    <el-button type="info" size="mini" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:5px;margin-left:30px">退出</el-button>
 
                </span>
            </div>
        </el-dialog>
 
        <!-- 报价明细新增 -->
        <el-dialog v-dialogDrag :visible.sync="prcWin" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{prcFlag==='create'?'新增记录':'编辑记录'}}</span>
            </div> 
            <Form :model="quoRow" :label-width="120" ref="dtlForm"  label-position="right" inline  :rules="ruleValidate">  
                <span v-for="(item,index) in prcCol" :key="index" >
                    <FormItem   :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                        <template slot="label"><span v-if="item.notnull=='Y'" style="color:red;margin-right:5px">*</span>{{item.title}}</template>
                        <el-date-picker  type="date"  v-if="item.edcss==='date'" v-model="quoRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                        <el-input-number :disabled="item.disabled==='Y'?true:false " :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="quoRow[item.key]" style="width:100%"></el-input-number> 
                        <el-checkbox disabled border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="quoRow[item.key]" style="width:100%"></el-checkbox> 
                        <el-select  v-else-if="item.key==='TAX'"  v-model="quoRow[item.key]"  style="width:100%" filterable>
                            <el-option v-for="(item,index) in taxArr" :key="index" :value="item.SUBNO" :label="item.CNAME" ></el-option>
                        </el-select> 
                        <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false||item.key=='OKRMK' "  v-model="quoRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" icon="iconfont icon-shanchu" size="small"  @click="prcWin=false" style="margin-right:50px;">取消</el-button>
                    <el-button type="primary" icon="iconfont icon-baocun"  size="small" @click="prcOk" style="margin-right:10px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="restoreFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
 
export default {
    name:'request_quote',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '15992',
            fieldIdseq: '15992',
            fieldLstseq: '1',
            mainColumnKey: 'mainTableCol',
            tableColumnKey: 'mainTableCol',
            initColumnKey: 'initCol',
            tableRef: 'refreq',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    data () {
        return {
            quoRow:{},
            prcWin:false,
            supWin:false,
            selparam3:'MATNM',
            txtparam3:'',
            oper3:'like',
            promptWin:false,
            taxArr:[],
         
            prcFlag:'create',
            addFlag:'create',
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            stfgSet:'ALL',
            oper2:'like',
            prompt:'',
            input_hold:'请输入内容...',
            ruleValidate:{},
            selparam:'IDNO',
            txtparam:'',
            prcRow:{},
            payArr:[],
            goPage:'',
            selparam2:'',
            txtparam2:'',
            reqData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            delBool:false,
            loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            supData:[],
            matData:[],
            addWin:false,
            v_username :this.$cookies.get('v_telno' ), //用户名称 
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_url:'xuper_auth/getTableRecMany', //api请求路径  
            pageList: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            dataCount:0,
            rowSize:50,
            supCol:[],
            matCol:[],
            reqCol:[],
            initCol:[],
            mainTableCol:[],
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            colory:'#959997', //审核颜色
            colorx:'#e00e66', //作废颜色
            v_idseq:this.$cookies.get('idseq'),
            supIndex:'',
            repWin:false,
            repUrl:'',
        }
    },
    components: {
        VeColumnConfigDialog,
 
    },
    computed: {
        tabWidth: function() {
            return (window.innerWidth - 120) + 'px';
        }, 
        subHeight: function() {
            return (window.innerHeight - 165) + 'px';
        }, 
        visibleMainTableColumns: function() {
            return this.mainTableCol.filter(item => item.thide === 'N' && this.getFieldVisible(item.key, true))
        },
    },
    mounted () {
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','PARENTNO','249','','','v_sys_base','').then(res=>{
            this.taxArr =res.result
        })
        //  //用户权限表
        // getBaseData('xuper_auth/getBaseData','idseq',this.$cookies.get('v_idseq') ,'frmidseq','397192','v_sys_user_priv','').then(res=>{           
        //     if (this.v_admin==='N') { //表示有权限控制
        //     console.log(res.result[0],JSON.stringify(res.result[0]) ,this.$cookies.get('v_idseq') )
        //         let row =res.result[0]
        //         if (row.ISADD==='N'){ //新增
        //             this.addBool=true
        //         }if (row.ISUPD==='N'){ //修改
        //             this.editBool=true
        //         }if (row.ISDEL==='N'){ //删除
        //             this.delBool=true
        //         }if (row.ISCFM==='N'){ //审核
        //             this.cfmBool=true
        //         }if (row.ISCANCEL==='N'){ //作废
        //             this.cancelBool=true
        //         }
        //     }
        // })  
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getPrcList('')   
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        handleMainTableColumnResize(newWidth, oldWidth, column){
            const key =column && (column.property || column.field)
            if (!key) return
            this.collectFieldWidth({ column: { field:key }, columnWidth:newWidth })
        },
        matQry(){
            let cond_=''
            if (this.selparam3){
                if (this.oper3==='like'){
                    cond_=cond_+' and '+this.selparam3+' like \'%'+this.txtparam3+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam3+this.oper3+'\''+this.txtparam3+'\''
                }
            }
            if (this.prcRow && this.prcRow['IDSEQ'])
            this.getMatList(this.prcRow['IDSEQ'],cond_)
        }, 
        repBtn(row){
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+'po_ask.cpt&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
        },
        prcOk(){
            if (!this.quoRow['TAXPRC']){
                this.promptWin=true
                this.prompt='单价不能为空'
            }else if (!this.quoRow['TAX']){
                this.promptWin=true
                this.prompt='税率不能为空'
            }else{
                
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/tableBodySave2',
                    data: {p_json:JSON.stringify( this.quoRow  ), p_table:'po_prc_matdtl' },
                }).then(res=>{   
                    if(res.code ==='200')  {     
                        //console.log(JSON.stringify( this.quoRow  ),res.idseq)     
                        this.prcWin=false
                        this.getQuoteList(this.quoRow['IDSEQ'],this.quoRow['LSTSEQ'])
                    }else{
                        this.prompt =res.result
                        this.promptWin=true
                    }        
                })        
            }
        },
        prcEdit(row){
            this.prcWin=true
            this.quoRow=JSON.parse(JSON.stringify(row))
            this.prcFlag='edit'
        },
        //报价明细  ,供应商只能查自己的
        getQuoteList(idseq,lstseq){
            getTabColOrData(this.v_url,'v_po_prc_matdtl','idseq',idseq,'lstseq',lstseq,'userno',this.v_username,'' ).then((res) => { 
                this.prcData =res.result 
            })
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.refprc.doLayout();
            }) 
        },
 
        prcVal(){
            // let tax_=Number(this.quoRow['TAX'])
            // let taxprc_=Number(this.quoRow['TAXPRC'])
            // this.quoRow['PRC'] =taxprc_/(100+tax_)*100
        },
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='YES'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.addFlag='edit'
            this.prcRow =JSON.parse(JSON.stringify(row))
            //供应商数据
            this.getSupList(row.IDSEQ)
            //产品数据
            this.getMatList(row.IDSEQ,'')
            this.addWin=true      
        },
 
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.ORDSTFG  === 'Y') {
                return 'success-row';
            } else if (row.ORDSTFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getSupKey(row){
            if (row.IDSEQ && row.LSTSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        getMatKey(row){
            if (row.IDSEQ && row.LSTSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        getPrcKey(row){
            if (row.IDSEQ && row.LSTSEQ&&row.ITMSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ+'-'+row.ITMSEQ
        },
        //状态作废
        stfgRec(row,val,index){
            let v_comm=''
            if (val==='Y'){
                v_comm='已报价'
            }else if (val==='N'){
                v_comm='未报价'
            }
            this.$confirm('你确定要把此单据变更为 '+v_comm+'吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getRecordCnt',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'userno',p_value2:this.v_username,p_table:'PO_PRCSTFG' },
                }).then(res=>{ 
                    if (res.result>0) {
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'userno',p_value2:this.v_username,p_table:'PO_PRCSTFG',p_cond:' set stfg=\''+val+'\' '},
                        }).then(res=>{      
                            this.reqData.splice(index,1,Object.assign(row,{ISPRC:val }) )           
                        })
                    }else{
                        let v_json =JSON.stringify( {'CORPID':this.v_corpid,'IDSEQ':row['IDSEQ'],'USERNO':this.v_username,'STFG':val } )
                    
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/tableBodySave',
                            data: {p_json:v_json, p_table:'PO_PRCSTFG',p_idseq:row['IDSEQ']},
                        }).then(res=>{ 
                            if (res.code=='200'){
                                this.reqData.splice(index,1,Object.assign(row,{ISPRC:val }) )   
                            }else{
                                this.promptWin =true
                                this.prompt =res.result
                            }
                        })
                    }
                })
            }).catch(()=>{})
             
        },
        //新增报价明细
        addQuote(row){
   
            this.prcWin =true
            this.quoRow={MATNM:row['MATNM'],MATDESC:row['MATDESC'],USERNO:this.v_username,IDSEQ:row['IDSEQ'],LSTSEQ:row['LSTSEQ'],ITMSEQ:'' }
            this.prcFlag='create'
 
        },
        // 行点击事件
        rowClick(row){
            //明细查询
            
            this.getQuoteList(row.IDSEQ,row.LSTSEQ)
        },
        //状态查询
        stfgChange(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and  '+this.selparam2+'  like  \'%' + this.txtparam2+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam2  +this.oper2+' \''+this.txtparam2+'\' '
                }
            }
            if (this.stfgSet!=='ALL'){
               if (this.stfgSet==='Y' ){ //已报价
                  cond_=cond_+'  and nvl(b.stfg,\'N\')=  \'Y\' '
               }else{
                  cond_=cond_+'  and nvl(b.stfg,\'N\')=  \'N\' '
               }
            }
            
            this.getPrcList(cond_)
        }, 
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        prcDel(row,index){
            this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row['IDSEQ'],p_key2:'lstseq',p_value2:row['LSTSEQ'],p_key3:'itmseq',p_value3:row['ITMSEQ'], p_table:'po_prc_matdtl' },
                }).then(res=>{
                    this.prcData.splice(index,1)
                })
            }).catch(()=>{})
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.reqData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.reqData = this.allList          
            }else{
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.reqData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.refreq.doLayout();
            }) 
        },
 
        //报价单 
        getPrcList(cond){ //   +
            let v_cond ='select rownum rn,a.*,nvl(b.stfg,\'N\') isprc from v_po_prc a,(select * from po_prcstfg where userno=\''+this.v_username+'\') b where a.idseq=b.idseq(+) and a.corpid=\''+this.v_corpid+'\' '+ cond
            let v_qry =''
            if (this.v_admin =='Y'){
                v_qry =' and a.cfmdttm is not null and a.stfg !=\'NO\' '
            }else{
                v_qry =' and a.cfmdttm is not null and a.stfg !=\'NO\' and a.idseq in (select idseq from v_po_prc_sup where phoneno  =\''+this.v_username+'\') '
            }
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getFreeData',
                data: { p_cond: v_cond+ v_qry +' order by '+this.selparam+' desc'},
            }).then(res=>{       
                this.allList =res.result 
                this.initPage() 
            })
        },
        //报价供应商 
        getSupList(idseq){
            let cond_ =' and supno in (select supno from V_SYS_USER_SUP where userno=\''+this.v_username+'\')'     
            getTabColOrData(this.v_url,'v_po_prc_sup','idseq',idseq,'','','','',cond_).then((res) => { 
                this.supData =res.result 
            })
        },
        //报价产品 
        getMatList(idseq,cond){
            getTabColOrData(this.v_url,'v_po_prc_mat','idseq',idseq,'','','','',cond).then((res) => { 
                this.matData =res.result 
                if (res.result.length>0){
                    this.getQuoteList(res.result[0].IDSEQ,res.result[0].LSTSEQ)
                    this.$refs['refmat'].setCurrentRow(res.result[0])
                  
                }else{
                    this.prcData=[]
                }
                this.$nextTick(()=>{
                    this.$refs['refmat'].doLayout()
                })
            })
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15992','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol =res.result
                vm.reqCol =res.result.map(item => ({
                    title: vm.$translate.getColTitle(item, vm.$store.state.lang),
                    key: item.key,
                    align: item.align,
                    width: item.width,
                    edcss:item.EDCSS,
                    thide:item.THIDE,
                    holder:item.HOLDER,
                    fhide:item.FHIDE,
                    disabled:item.DISABLED,
                    dotnum:item.DOTNUM,
                    sortable:item.SORTABLE,
                }))
                return vm.loadInitialFieldSettings().then(() => {
                    vm.mainTableCol =vm.sortFieldRows(vm.initCol).map(item => ({
                        title: vm.$translate.getColTitle(item, vm.$store.state.lang),
                        key: item.key,
                        align: item.align,
                        width: vm.getFieldWidth(item.key, item.width) || 120,
                        edcss:item.EDCSS,
                        thide:item.THIDE,
                        holder:item.HOLDER,
                        fhide:item.FHIDE,
                        disabled:item.DISABLED,
                        dotnum:item.DOTNUM,
                        sortable:item.SORTABLE,
                    }))
                    vm.applyFieldSettingRows()
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15992','lstseq','3','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.supCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15992','lstseq','4','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.matCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15992','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prcCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .item-width  {
        width: 32%;
        color:#409EFF;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
</style>
